import { Controller } from "@hotwired/stimulus"
import Cropper from "cropperjs"

// Crop box for a media file. Mirrors the live crop rectangle into the hidden
// fields the form posts, and lets the aspect-ratio select reshape it.
//
// cropperjs does the actual work and has never needed jQuery — the old version
// only used it to read and write six inputs, which is what this replaces.
export default class extends Controller {
    static targets = ["image", "x", "y", "width", "height", "scaleX", "scaleY", "ratio", "versionName"]

    connect() {
        if (!this.hasImageTarget) return

        this.cropper = new Cropper(this.imageTarget, {
            aspectRatio: 1,
            zoomable: false,
            data: { x: 0, y: 0 },
            crop: (event) => this.#write(event.detail),
        })
    }

    disconnect() {
        this.cropper?.destroy()
        this.cropper = null
    }

    // Bound to the "Change" button next to the ratio select.
    applyRatio(event) {
        event.preventDefault()
        if (!this.cropper || !this.hasRatioTarget) return

        this.cropper.setAspectRatio(parseFloat(this.ratioTarget.value))

        if (this.hasVersionNameTarget) {
            const option = this.ratioTarget.selectedOptions[0]
            if (option) this.versionNameTarget.value = option.text
        }
    }

    #write({ x, y, width, height, scaleX, scaleY }) {
        const set = (target, value) => {
            if (target) target.value = value
        }

        set(this.hasXTarget && this.xTarget, x)
        set(this.hasYTarget && this.yTarget, y)
        set(this.hasWidthTarget && this.widthTarget, width)
        set(this.hasHeightTarget && this.heightTarget, height)
        set(this.hasScaleXTarget && this.scaleXTarget, scaleX)
        set(this.hasScaleYTarget && this.scaleYTarget, scaleY)
    }
}
